import { render, staticRenderFns } from "./Resultat.vue?vue&type=template&id=ffe96236&scoped=true"
import script from "./Resultat.vue?vue&type=script&lang=js"
export * from "./Resultat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffe96236",
  null
  
)

export default component.exports